import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex justify-center bg-gray-500 bg-opacity-50" }
const _hoisted_2 = {
  id: "crud-modal",
  tabindex: "-1",
  class: "overflow-y-auto overflow-x-hidden justify-center items-center"
}
const _hoisted_3 = { class: "relative p-4 w-[40vw] max-h-full" }
const _hoisted_4 = { class: "relative bg-white rounded-lg shadow dark:bg-gray-700" }
const _hoisted_5 = { class: "flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600" }
const _hoisted_6 = { class: "p-4 md:p-5" }
const _hoisted_7 = { class: "grid gap-4 mb-4 grid-cols-2" }
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = { class: "col-span-2 sm:col-span-1" }
const _hoisted_11 = { class: "col-span-2" }
const _hoisted_12 = { class: "flex items-center justify-center w-full mb-3" }
const _hoisted_13 = {
  for: "coverImg",
  class: "flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
}
const _hoisted_14 = {
  key: 0,
  class: "flex w-full mb-3"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex items-center justify-center w-full" }
const _hoisted_17 = {
  for: "images",
  class: "flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
}
const _hoisted_18 = {
  key: 1,
  class: "flex w-full gap-3 overflow-scroll mb-3"
}
const _hoisted_19 = ["src"]

import { ref, computed } from 'vue';
import {
  uploadBytes,
  getDownloadURL,
  ref as storageRef,
} from 'firebase/storage';
import { addDoc, collection } from 'firebase/firestore';
import { db, storage } from '@/config/firebase';

interface Service {
  title: string;
  subTitle: string;
  category: string;
  description: string;
  coverImg: string;
  images: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceModal',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const service = ref<Service>({
  title: '',
  subTitle: '',
  category: '',
  description: '',
  coverImg: '',
  images: [],
});

const coverImgFile = ref<File | null>(null);
const imageFiles = ref<File[]>([]);

const coverImgUrl = computed(() => (coverImgFile.value ? URL.createObjectURL(coverImgFile.value) : null));

// Computed property for multiple image URLs
const imageUrls = computed(() => imageFiles.value.map((file) => URL.createObjectURL(file)));

function onFileChange(event: Event, type: string) {
  const target = event.target as HTMLInputElement;
  if (type === 'coverImg' && target.files) {
    const [targetFile, ...rest] = target.files;
    coverImgFile.value = targetFile;
  } else if (type === 'images' && target.files) {
    imageFiles.value = Array.from(target.files);
  }
}

function resizeImage(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    img.onload = () => {
      const aspectRatio = img.width / img.height;
      if (img.width > 1250) {
        canvas.width = 1250;
        canvas.height = 1250 / aspectRatio;
      } else {
        canvas.width = img.width;
        canvas.height = img.height;
      }

      if (ctx) {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            const resizedFile = new File([blob], file.name, {
              type: file.type,
            });
            resolve(resizedFile);
          } else {
            reject(new Error('Canvas to Blob conversion failed'));
          }
        }, file.type);
      } else {
        reject(new Error('Canvas context is not available'));
      }
    };

    img.onerror = (error) => reject(error);
    img.src = URL.createObjectURL(file);
  });
}

async function uploadFile(file: File): Promise<string> {
  const resizedFile = await resizeImage(file);
  const fileRef = storageRef(storage, `services/${resizedFile.name}`);
  const snapshot = await uploadBytes(fileRef, resizedFile);
  return getDownloadURL(snapshot.ref);
}

async function addService() {
  try {
    if (coverImgFile.value) {
      service.value.coverImg = await uploadFile(coverImgFile.value);
    }

    if (imageFiles.value.length > 0) {
      for (const file of imageFiles.value) {
        const url = await uploadFile(file);
        service.value.images.push(url);
      }
    }

    await addDoc(collection(db, 'services'), service.value);

    alert('Service added successfully!');
    // Reset form
    service.value = {
      title: '',
      subTitle: '',
      category: '',
      description: '',
      coverImg: '',
      images: [],
    };
    coverImgFile.value = null;
    imageFiles.value = [];
    emit('close');
  } catch (error) {
    console.error('Error adding service: ', error);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white" }, " Add New Service ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white",
              "data-modal-toggle": "crud-modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("svg", {
                class: "w-3 h-3",
                "aria-hidden": "true",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 14 14"
              }, [
                _createElementVNode("path", {
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                })
              ], -1),
              _createElementVNode("span", { class: "sr-only" }, "Close modal", -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  for: "title",
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                }, "Title", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((service.value.title) = $event)),
                  type: "text",
                  name: "title",
                  id: "title",
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                  placeholder: "Type service title"
                }, null, 512), [
                  [_vModelText, service.value.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  for: "subTitle",
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                }, "SubTitle", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((service.value.subTitle) = $event)),
                  type: "text",
                  name: "subTitle",
                  id: "subTitle",
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                  placeholder: "Type service subTitle"
                }, null, 512), [
                  [_vModelText, service.value.subTitle]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  for: "category",
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                }, "Category", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((service.value.category) = $event)),
                  type: "text",
                  name: "category",
                  id: "category",
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                  placeholder: "Type service category"
                }, null, 512), [
                  [_vModelText, service.value.category]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  for: "description",
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                }, "Description", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((service.value.description) = $event)),
                  id: "description",
                  rows: "4",
                  class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                  placeholder: "Write service description here"
                }, null, 512), [
                  [_vModelText, service.value.description]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, [
                _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"flex flex-col items-center justify-center pt-5 pb-6\"><svg class=\"w-8 h-8 mb-4 text-gray-500 dark:text-gray-400\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 16\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2\"></path></svg><p class=\"mb-2 text-sm text-gray-500 dark:text-gray-400\"><span class=\"font-semibold\">Click to upload cover image</span></p><p class=\"text-xs text-gray-500 dark:text-gray-400\"> SVG, PNG, JPG or GIF (MAX. 800x400px) </p></div>", 1)),
                _createElementVNode("input", {
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (onFileChange($event, 'coverImg'))),
                  id: "coverImg",
                  type: "file",
                  class: "hidden"
                }, null, 32)
              ])
            ]),
            (coverImgUrl.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: coverImgUrl.value,
                      alt: "Cover Image",
                      class: "w-60 rounded-lg"
                    }, null, 8, _hoisted_15)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, [
                _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"flex flex-col items-center justify-center pt-5 pb-6\"><svg class=\"w-8 h-8 mb-4 text-gray-500 dark:text-gray-400\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 16\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2\"></path></svg><p class=\"mb-2 text-sm text-gray-500 dark:text-gray-400\"><span class=\"font-semibold\">Click to upload additional images</span></p><p class=\"text-xs text-gray-500 dark:text-gray-400\"> SVG, PNG, JPG or GIF (MAX. 800x400px) </p></div>", 1)),
                _createElementVNode("input", {
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (onFileChange($event, 'images'))),
                  id: "images",
                  type: "file",
                  class: "hidden",
                  multiple: ""
                }, null, 32)
              ])
            ]),
            (imageUrls.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageUrls.value, (image, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: index,
                      src: image,
                      alt: "Cover Image",
                      class: "w-60 object-cover rounded-lg"
                    }, null, 8, _hoisted_19))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: addService,
              class: "relative inline-flex items-center justify-center p-0.5 mb-2 me-2 mt-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800"
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("span", { class: "relative inline-flex items-center px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0" }, [
                _createElementVNode("svg", {
                  class: "me-1 -ms-1 w-5 h-5",
                  fill: "currentColor",
                  viewBox: "0 0 20 20",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
                    "clip-rule": "evenodd"
                  })
                ]),
                _createTextVNode(" Add new service ")
              ], -1)
            ]))
          ])
        ])
      ])
    ])
  ]))
}
}

})